import { useEffect, useState } from "react";

export default function PublishModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [notice, setNotice] = useState("");

  useEffect(() => {
    if (!open) return;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open, onClose]);

  useEffect(() => {
    if (!open) {
      setNotice("");
    }
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center px-4">
      <button
        type="button"
        aria-label="关闭发布窗口"
        onClick={onClose}
        className="absolute inset-0 cursor-pointer bg-foreground-950/50"
      />
      <div className="animate-fade-up relative w-full max-w-lg rounded-lg border border-background-200 bg-background-50 p-6">
        <div className="flex items-start justify-between gap-4">
          <div>
            <p className="font-label text-[11px] tracking-[0.2em] text-primary-600">发布帖子</p>
            <h2 className="mt-1 font-heading text-lg font-bold text-foreground-950">发布新帖子</h2>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="关闭"
            className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-md text-foreground-500 transition-colors hover:bg-background-100 hover:text-foreground-900"
          >
            <i className="ri-close-line text-xl" />
          </button>
        </div>

        <div className="mt-4 flex items-start gap-2 rounded-md border border-dashed border-primary-300 bg-primary-50 px-3 py-2.5 text-xs leading-relaxed text-primary-800">
          <i className="ri-lock-line mt-0.5 shrink-0" />
          <span>
            发布帖子需要登录，本站暂未接入账号系统与后端存储。你可以先填写内容，但提交不会真正发布任何信息。
          </span>
        </div>

        <div className="mt-4 space-y-3">
          <label className="block">
            <span className="text-xs text-foreground-500">帖子标题</span>
            <input
              type="text"
              value={title}
              onChange={(event) => setTitle(event.target.value)}
              maxLength={40}
              placeholder="例如：想聊聊《雾港》第六集的结尾"
              className="mt-1.5 w-full rounded-md border border-background-300 bg-background-50 px-3 py-2 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none"
            />
          </label>
          <label className="block">
            <span className="text-xs text-foreground-500">正文内容</span>
            <textarea
              value={content}
              onChange={(event) => setContent(event.target.value.slice(0, 500))}
              rows={5}
              maxLength={500}
              placeholder="写下你的观点，最多 500 字"
              className="mt-1.5 w-full resize-none rounded-md border border-background-300 bg-background-50 px-3 py-2 text-sm leading-relaxed text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none"
            />
            <span className="mt-1 block text-right font-label text-[11px] text-foreground-400">
              {content.length} / 500
            </span>
          </label>
        </div>

        {notice && (
          <div className="mt-3 rounded-md bg-background-100 px-3 py-2 text-xs leading-relaxed text-foreground-600">
            {notice}
          </div>
        )}

        <div className="mt-4 flex flex-wrap items-center justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            className="cursor-pointer whitespace-nowrap rounded-full border border-background-300 px-4 py-2 text-sm text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            取消
          </button>
          <button
            type="button"
            onClick={() =>
              setNotice(
                "演示状态：发布入口暂未接入登录与后端服务，你的内容不会被保存或公开。等账号功能上线后即可正式发布。",
              )
            }
            className="cursor-pointer whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-primary-600"
          >
            登录后发布（演示）
          </button>
        </div>
      </div>
    </div>
  );
}